module.exports = __webpack_public_path__ + "static/Haps-Globe-bf731eba70258927eb16ee1257090158.svg";